import React, {useState, useRef, useCallback, useEffect} from 'react'
import {useSelector} from 'react-redux';
import { coursePeriodsWeeks } from '../../../components/clients/utils/ClientsMessageModal';
import { InputCheckbox } from '../../checkbox/InputCheckbox';
import {coursePeriods, roleCurator, roleTechnicalSpecialist, smiles, userStatusFired} from '../../../constants';
import {i_attach, i_close, i_smile} from "../../../icons";
import {ChatAddFile} from "../../../components/chat/utils/ChatAdd";
import {TextareaChat} from "../../textarea/TextareaChat";
import {SelectModal} from "../../select/SelectModal";
import { InputProfile } from '../../input/InputProfile';

export function ActionNodeMessage({form, errors, loading, setForm, user}) {
    const users = useSelector(state => state.user.users_list);
    const curatorId = user && user.id && user.role_id === roleCurator ? user.id : null;
    const [weeks] = useState(coursePeriodsWeeks());
    const [checkedAll, setCheckedAll] = useState(false);
    const inputRef = useRef();

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.value = form.message || '';
      }
    }, []);
  
    const handleChangeForm = useCallback((e) => {
      const name = e.target.name;
      const value = e.target.value;
      setForm({...form, [name]: value});
    }, [form, setForm]);
  
    const handleCheckedInArchive = () => {
      let in_archive = form.in_archive;
      in_archive = !in_archive
      setForm({...form, in_archive});
    };
  
    const handleCheckedInWeek = () => {
      let in_week = form.in_week;
      in_week = !in_week
      setForm({...form, in_week});
    };

    const handleCheckedDify = (field) => {
      let value = form[field] || false;
      value = !value;
      setForm({...form, [field]: value});
    };
  
    const handleCheckedAll = () => {
      let program_stages = {}, program_stages_weeks = {};
      if (!checkedAll) {
        for (let sk in weeks) {
          program_stages[sk] = true;
          for (let k in weeks[sk]) {
            program_stages_weeks[weeks[sk][k]] = true;
          }
        }
      }
      setCheckedAll(!checkedAll);
      setForm({...form, program_stages, program_stages_weeks});
    };
  
    const handleChecked = (value) => {
      let values = {...form.program_stages};
      let program_stages_weeks = {...form.program_stages_weeks};
      if (values.hasOwnProperty(value) && values[value]) {
        delete values[value];
        for (let k in weeks[value]) {
          if (program_stages_weeks.hasOwnProperty(weeks[value][k]) && program_stages_weeks[weeks[value][k]]) {
            delete program_stages_weeks[weeks[value][k]];
          }
        }
        setForm({...form, program_stages: values, program_stages_weeks});
        setCheckedAll(false);
      } else {
        values[value] = true;
        for (let k in weeks[value]) {
          program_stages_weeks[weeks[value][k]] = true;
        }
        setForm({...form, program_stages: values, program_stages_weeks});
      }
    };
  
    const handleCheckedWeek = (stage, value) => {
      let program_stages = {...form.program_stages};
      let program_stages_weeks = {...form.program_stages_weeks};
      if (program_stages_weeks.hasOwnProperty(value) && program_stages_weeks[value]) {
        delete program_stages_weeks[value];
        let empty = true;
        for (let k in weeks[stage]) {
          if (program_stages_weeks[weeks[stage][k]]) {
            empty = false;
            break;
          }
        }
        if (empty) {
          delete program_stages[stage];
        }
        setForm({...form, program_stages, program_stages_weeks});
        setCheckedAll(false);
      } else {
        program_stages_weeks[value] = true;
        setForm({...form, program_stages_weeks});
      }
    };
  
    const handleSmile = (e) => {
      insertToMessage(e.target.value);
    };
  
    const insertToMessage = (value) => {
      if (inputRef.current.value.length + value.length > 4096) {
        return;
      }
      const current = inputRef.current.value;
      const position = inputRef.current.selectionStart;
      inputRef.current.value = current.substring(0, position) +
          value +
          current.substring(position, current.length);
      inputRef.current.focus();
      inputRef.current.setSelectionRange(position + value.length, position + value.length);
      setForm({...form, message: inputRef.current.value});
    };
  
    const setFile = (file) => {
      setForm({...form, file: file});
    };

    const handleMessageChange = (e) => {
      setForm({...form, message: inputRef.current.value});
    };
  
    /*
    const handleSubmit = () => {
      console.log('------>')
      if (loading) {
        return false;
      }
      let errs = {};
      const values = {...form};
      values.program_stages = Object.keys(values.program_stages);
      values.program_stages_weeks = Object.keys(values.program_stages_weeks);
      values.message = inputRef.current.value.trim();
      if (!values.message && !values.file) {
        errs.message = true;
      }
      setErrors(errs);
      if (Object.keys(errs).length > 0) {
        return;
      }
    }
    */
  
    return <div className="modal__scroll">
      {user && user.role_id === roleTechnicalSpecialist && <div className="modal__inner modal__inner--left">
          <InputCheckbox name="in_archive" title="В архиве" checked={form.in_archive} onChange={() => handleCheckedInArchive()}/>
      </div>}

      <div className="modal__inner modal__inner--left">
        <div className="profile__group">
          <label className="profile__label help">Отправлять 1 раз в N часов</label>
          <input type="number" name="send_hour_limit" value={form.send_hour_limit} onChange={handleChangeForm} className="profile__input input" />
        </div>
      </div>

      <div className="modal__inner modal__inner--left">
        <SelectModal title="Получатель сообщения"
                                                    name="recipient"
                                                    value={form.recipient}
                                                    error={errors.recipient}
                                                    disabled={loading}
                                                    onChange={handleChangeForm}>
          <option value={1}>Клиент, по которому событие</option>
          <option value={2}>Куратор клиента, по которому событие</option>
          <option value={3}>Технический специалист</option>
          <option value={4}>Клиенты из списка</option>
        </SelectModal>
      </div>

      {parseInt(form.recipient) === 4 && <>
    
      <div className="modal__inner modal__inner--left">
          <InputCheckbox name="in_week" title="Всем на программе week" checked={form.in_week} onChange={() => handleCheckedInWeek()}/>
      </div>
  
      {!form.in_archive  && !curatorId && <div className="modal__inner">
        <SelectModal title="Всем пользователям куратора"
                                                    name="curator_id"
                                                    value={form.curator_id}
                                                    error={errors.curator_id}
                                                    disabled={loading}
                                                    onChange={handleChangeForm}>
          <option value="">Все</option>
          {
            users && users.map(i => i.value && (i.role_id !== roleTechnicalSpecialist) && (i.status !== userStatusFired) && <option key={i.value} value={i.value}>{i.text}</option>)
          }
        </SelectModal>
      </div>}
      {!form.in_archive && !form.in_week && <div className="modal__inner modal__inner--left">
        <div className="modal__group">
          <p className="modal__help">Ступень программы</p>
          <InputCheckbox name="checkedAll" title="Всем" checked={checkedAll}
                         onChange={() => handleCheckedAll()}/>
          {coursePeriods.map((i, k) => {
              return <React.Fragment key={k}>
                <InputCheckbox name={k} title={i.title} checked={form.program_stages[k] || false}
                             onChange={() => handleChecked(k)}/>
                {form.program_stages[k] && i.days / 7 > 1 && <div className="square-checkbox__sub">
                  <InputCheckbox name={k + '_1'} title="1-я неделя" checked={form.program_stages_weeks[weeks[k][1]] || false}
                                 onChange={() => handleCheckedWeek(k, weeks[k][1])}/>
                  <InputCheckbox name={k + '_2'} title="2-я неделя" checked={form.program_stages_weeks[weeks[k][2]] || false}
                                 onChange={() => handleCheckedWeek(k, weeks[k][2])}/>
                  {i.days / 7 > 2 && <InputCheckbox name={k + '_3'} title="3-я неделя" checked={form.program_stages_weeks[weeks[k][3]] || false}
                                                    onChange={() => handleCheckedWeek(k, weeks[k][3])}/>}
                  {i.days / 7 > 3 && <InputCheckbox name={k + '_4'} title="4-я неделя" checked={form.program_stages_weeks[weeks[k][4]] || false}
                                                    onChange={() => handleCheckedWeek(k, weeks[k][4])}/>}
                </div>}
              </React.Fragment>
            }
          )}
        </div>
      </div>}
    
      {form.in_archive && <div className="modal__inner modal__inner--left">
        <SelectModal title="Всем пользователям куратора"
                                                    name="course"
                                                    value={form.course}
                                                    error={errors.course}
                                                    disabled={loading}
                                                    onChange={handleChangeForm}>
          <option value="1">Полная программа</option>
          <option value="2">Рассрочка</option>
          <option value="3">Без купленных курсов</option>
          <option value="4">Все</option>
          <option value="5">Неделя</option>
        </SelectModal>
      </div>}
  
      {!form.in_archive && <div className="modal__inner modal__inner--left">
        <SelectModal title="Последнее сообщение"
                     name="last_message"
                     value={form.last_message}
                     error={errors.last_message}
                     disabled={loading}
                     onChange={handleChangeForm}>
          <option value={0}>Последнее сообщение</option>
          <option value={3}>3 дня</option>
          <option value={4}>4 дня</option>
          <option value={5}>5 дней</option>
        </SelectModal>
      </div>}
      </>}

      <div className="modal__inner modal__inner--left">
        <div className="profile__group" style={{width:'35%'}}>
          <InputCheckbox name="dify_enabled" title="Использовать AI" checked={form.dify_enabled} onChange={() => handleCheckedDify('dify_enabled')}/>
        </div>
        {form.dify_enabled && <>
          <div className="profile__group">
            <InputCheckbox name="dify_one_per_client" title="Один запрос на клиента" checked={form.dify_one_per_client} onChange={() => handleCheckedDify('dify_one_per_client')}/>
          </div>
          
          <InputProfile type="text"
                          title="Ключ Dify API"
                          name="dify_key"
                          placeholder="Введите ключ Dify API"
                          value={form.dify_key}
                          error={errors.dify_key || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
         
        </>}
      </div>
  
      <div className="chat-panel__inner">
        <ChatAddFile handleChange={setFile} loading={loading}/>
        <TextareaChat inputRef={inputRef} loading={loading} placeholder="Написать..." minHeight={104} 
            handleSubmit={() => {}}
            handleChange={handleMessageChange}
            />
        <button type="button" className="chat-panel__icon">
          {i_smile()}
          <ul className="dropdown dropdown--top dropdown--flex">
            {smiles.map((i, k) => <li key={k} className="dropdown__item">
              <input type="button" value={i} className="dropdown__smile" onClick={handleSmile} />
            </li>)}
          </ul>
        </button>
      </div>
      {form.file !== null && <div className="chat-panel__attached">
        <div className="attached--item"><span className="attached--icon">{i_attach()}</span> {form.file.name} <span className="attached--close" onClick={() => setFile(null)}>{i_close()}</span></div>
      </div>}
      <div className="template">
        <button type="button" className="template__item" onClick={() => insertToMessage('{real_name}')}>real_name</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{day}')}>day</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{stage}')}>stage</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{course_name}')}>course_name</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{city}')}>city</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{curator_name}')}>curator_name</button><br /><br />
        <button type="button" className="template__item" onClick={() => insertToMessage('{curator_photo}')}>curator_photo</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{control}')}>control</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{start_at_human}')}>start_at_human</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{questionnaire_url}')}>questionnaire_url</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{tg_action}')}>tg_action</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{meal_plan_weekday_1}')}>meal_plan_weekday_1</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{meal_plan_weekend_1}')}>meal_plan_weekend_1</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{meal_plan_weekday_2}')}>meal_plan_weekday_2</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{meal_plan_weekend_2}')}>meal_plan_weekend_2</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{wake_time_weekday}')}>wake_time_weekday</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{wake_time_weekend}')}>wake_time_weekend</button>
      </div>
    </div>
  }